import { Module } from '../Module';

export interface IUploadIframeScope extends ng.IScope {
  handleResult(result: any): any;

  // This is the name of the iframe. It is exposed outside the directive
  // so that forms can use it to submit to this iframe
  // background info here: https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/Forms/Sending_forms_through_JavaScript
  iframeId: string;
}

interface IUploadIframeAttrs extends ng.IAttributes {
  name: string;
}

let id = 0;

Module.instance().directive('tbUploadIframe', <any[]>[() => {
  return {
    scope: {
      handleResult: '&',
      iframeId: '=?' // passed out
    },
    restrict: 'E',
    replace: true,
    link: (scope: IUploadIframeScope, element: JQuery, attrs: IUploadIframeAttrs) => {
      scope.iframeId = 'upload-iframe-' + id++;

      // IMPORTANT!
      // The iframe needs to be created with the name property set in order for it to work as a form submit target.
      // The name prop cannot be copied down to the element later by angular or the form submit won't go to the iframe.
      const iframe = angular.element(
        '<iframe name="' + scope.iframeId + '" ' +
        'border="0" width="0" height="0" ' +
        'style="width:0px;height:0px;border:none;display:none">'
      );

      element.after(iframe);

      iframe.on('load', () => {
        const result = iframe.prop('contentWindow').result;
        // IE will call load when the iframe is first added to the DOM,
        // so make sure we actually have a result.
        if(result) {
          scope.handleResult(result);
        }
      });
    }
  };
}]);

